import React from "react";

/** Header slot — typically status / title row; children keep existing business UI. */
export function HrOrderHeader({ children, className = "" }) {
  return <div className={`hr-order-header${className ? ` ${className}` : ""}`.trim()}>{children}</div>;
}
